module.exports = __webpack_public_path__ + "img/lv3.ed529e9f.png";